import { InjectionToken } from '@angular/core';

export interface MdeInventoryModuleConfig {
  showConfirmationOnFinalize?: boolean;
}

export const SOFTLINE_CONFIG_MDE_INVENTORY = new InjectionToken<MdeInventoryModuleConfig>(
  'SOFTLINE_CONFIG_MDE_INVENTORY'
);
